import { createFileRoute } from '@tanstack/react-router';

import Overview from 'component/view/SiteDetails/Overview';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/overview')({
  component: Overview,
});
